// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayControllersModelsScheduleEventType } from './tCApiGatewayControllersModelsScheduleEventType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel {
    'transactionId'?: number;
    'tcAccountId'?: string | null;
    'dueDateTimeEasternTime'?: Moment;
    'patientResponse'?: TCApiGatewayControllersModelsScheduleEventType;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel>> = [
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "number"
        },
        {
            "name":     "tcAccountId",
            "baseName": "tcAccountId",
            "type":     "string"
        },
        {
            "name":     "dueDateTimeEasternTime",
            "baseName": "dueDateTimeEasternTime",
            "type":     "Date"
        },
        {
            "name":     "patientResponse",
            "baseName": "patientResponse",
            "type":     "TCApiGatewayControllersModelsScheduleEventType"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel.attributeTypeMap;
    }
}
